// assets/converter-toast.js
class FlexaConverterToast extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.toastId = `toast-${Date.now()}-${Math.random()}`;
    this.validTypes = ["info", "success", "warning"];
    this.initialized = false;
    this.shadowRoot.innerHTML = `
      <div class="toast" part="toast">
        <span class="message" part="message"></span>
      </div>
    `;
  }

  static get observedAttributes() {
    return ["message", "duration", "dismissable", "type"];
  }

  connectedCallback() {
    if (!this.initialized) {
      this.render();
      this.initialized = true;
    }
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.addEventListener("show", (event) => {
      const { message, options } = event.detail;
      this.show(message, options);
    });

    this.addEventListener("hide", () => this.hide());
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue && this.initialized) {
      setTimeout(() => this.render(), 5);
    }
  }

  render() {
    const message = this.getAttribute("message") || "";
    const duration = parseInt(this.getAttribute("duration")) || -1;
    const dismissable = this.hasAttribute("dismissable");
    const type = this.validTypes.includes(this.getAttribute("type"))
      ? this.getAttribute("type")
      : "info";

    this.setAttribute("toast-id", this.toastId);
    this.setAttribute("type", type);

    const toastContainer = this.shadowRoot.querySelector(".toast");
    toastContainer.innerHTML = `
      <span class="message" part="message">${message}</span>
      ${dismissable ? '<button class="close-btn" part="close-btn">×</button>' : ""}
    `;

    const styles = {
      info: { bg: "#007bff", color: "#fff" },
      success: { bg: "#28a745", color: "#fff" },
      warning: { bg: "#dc3545", color: "#fff" },
    };

    this.style.setProperty("--toast-bg", styles[type].bg);
    this.style.setProperty("--toast-color", styles[type].color);

    if (dismissable) {
      toastContainer.querySelector(".close-btn").addEventListener("click", () => this.hide());
    }

    if (duration > 0) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => this.hide(), duration);
    }
  }

  show(message, options = {}) {
    const { duration = -1, dismissable = false, type = "info" } = options;

    this.setAttribute("message", message);
    this.setAttribute("type", type);
    this.setAttribute("duration", duration);

    dismissable ? this.setAttribute("dismissable", "") : this.removeAttribute("dismissable");

    this.hidden = false;

    if (!this.initialized) {
      this.render();
      this.initialized = true;
    }

    return this.toastId;
  }

  hide() {
    this.hidden = true;
    clearTimeout(this.timeout);
  }

  getToastId() {
    return this.toastId;
  }
}

customElements.define("flexa-converter-toast", FlexaConverterToast);
